<template>
    <div
        class="add-box"
        :class="{'school-center': curTheme}"
    >
        <div class="add" @click="handleAdd">
            <!--<div v-if="auth.ppt" class="btn import-ppt" @click="handleImportPPT">-->
                <!--<span class="ico-box">-->
                    <!--<span class="ico iconfont icon-bianzu"></span>导入pptx-->
                <!--</span>-->
            <!--</div>-->
            <div v-if="auth.add" class="btn add-new">
                <span class="ico-box">
                    <span class="ico">+</span>
                    <span class="name">新建空课件</span>
                </span>
            </div>
        </div>
        <div v-if="!showProBtn" class="ppt-box" @click="handleImportPPT">
            <p class="ppt"><span class="ico iconfont icon-bianzu"></span></p>
            <p class="name">导入PPT</p>
        </div>
        <el-popover
           v-else
            placement="bottom-start"
            width="240"
            trigger="hover">
            <div class="uploadPPTInfo">
                <div class="title">{{uploadPPtName}}</div>
                <div class="progress">
                <el-progress class="item" :percentage="$store.state.curPPTRate" color="#e6a23c"></el-progress>
                </div>
                <div style="text-align: right; margin-top: 10px">
                <span style="color:red;cursor: pointer;" @click="handleEndPPT">结束</span>
                </div>
            </div>
            <div class="ppt-box" slot="reference">
            <p class="ppt"><i class="el-icon-loading"></i></p>
            <p class="name">{{showProTxt}}</p>
            </div>
         </el-popover>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    export default {
        name: "add-template",
        props: {
            name: String,
            auth: Object,
            uploadPPtName:String,
            showProTxt: String,
            showProBtn:Boolean
        },
        computed: {
            ...mapGetters(['curTheme'])
        },
        methods: {
            handleAdd(){
                this.$emit('onNew')
            },
            handleImportPPT(){
                this.$emit('onPPT')
            },             
            handleEndPPT(){
                this.$emit('onEnd')
            }
        }
    }
</script>

<style lang="scss" scoped>
.add-box{
    display: flex;
    flex-direction: column;
    margin-left: 30px;
    margin-bottom: 20px;
    width: 250px;
    height: 200px;

    .add{
        background-color: #fff;
        border-radius: 5px;
        border: 1px solid rgba(0, 0, 0, 0.06);
        box-shadow:0px 2px 4px 0px rgba(0, 0, 0, 0.06);
        display: flex;
        flex: 1;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        .btn{
            width: 148px;
            height: 40px;
            background: #e7622e;
            border-radius: 20px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            color: white;
            margin: 6px 0px;
            font-size: 14px;

            &:hover{
                opacity: .8;
            }
            &:active{
                opacity: .6;
            }

            .ico-box{
                .ico{
                    margin-right: 6px;
                }
            }
        }

        .sp-add{
            color: #8D939D;
            font-size: 30px;
        }

        .img{
            width: 50px;
            height: 50px;
            object-fit: contain;
        }

        .name{
            font-size:14px;
            color:#909399;
            /*margin-top: 8px;*/
        }
    }

    .ppt-box{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        background-color: #e7622e;
        border-radius: 5px;
        margin-top: 10px;
        padding: 10px 0px;
        box-shadow:0px 1px 2px 0px rgba(0, 0, 0, 0.06);
        cursor: pointer;

        &:active{
            opacity: .8;
        }

        .ppt{
            margin-right: 20px;

            .img{
                width: 30px;
                height: 30px;
                object-fit: contain;
                position: relative;
                top: 4px;
            }
            .name{
                font-size: 14px;
                color: #333333;
            }
        }
    }
}
.add-box{
    width: 268px;
    height: 224px;
    margin-left: 22px;

    .add{
        width: 100%;
        height: 142px;
        background: white;
        box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        border: 1px solid #DCDFE6;

        &:hover{
            background: #F5F7FA;

            .add-new {
                .ico-box {
                    .ico {
                        color: #303133;;
                    }

                    .name {
                        color: #303133;
                    }
                }
            }
        }
        .add-new{
            background-color: initial;

            .ico-box{
                display: flex;
                flex-direction: column;
                align-items: center;

                .ico{
                    font-size: 20px;
                    color: #909399;;
                }
                .name{
                    font-weight: 500;
                    color: #909399;
                    line-height: 14px;
                    margin-top: 4px;
                }
            }
        }
    }
    .ppt-box{
        width: 100%;
        height: 64px;
        background: white;
        box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        padding: 0;
        margin-top: 16px;
        color: #909399;

        &:hover{
            background: #F5F7FA;
            color: #303133;
        }

        .ppt{
            margin-right: 9px;
        }
        .name{
            font-size: 16px;
        }
    }

}
.uploadPPTInfo{
    padding: 15px 10px;
  .title{
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
  }
  .progress{
    position: relative;
    height: 20px;
    .item{
      width: 100%;
      position: absolute;
      top:5px;
      left: 5px;
    }
  }
  .progress{
    margin-top: 15px;
  }
}
</style>
